export default {
  motorbike: 0.9578,
  car: 0.0356,
  others: 0.0066,
};
